import {
  learnerProfilesPath,
  transactionsPathV2,
  transcriptsPath,
  websiteHomePath
} from "@outschool/routes";

export const DASHBOARD_LINKS = [
  {
    label: "Classes",
    to: websiteHomePath()
  },
  {
    label: "Transcripts",
    to: transcriptsPath()
  },
  {
    label: "Transactions",
    to: transactionsPathV2()
  },
  {
    label: "Learner Profiles",
    to: learnerProfilesPath()
  }
] as const;
